<template>
  <div class="" style="width: 100%">  
    <div class="c-text-between c-text-both c-position-fixed c-width-precent-100 px-container"
    style="background: white;box-shadow: 0px 0px 26px rgb(0 0 0 / 7%);height: 90px;top: 0;z-index: 50;"> 
    <div class="logo-container" @click="$router.push('/')" style="cursor: pointer;">
      <img class="logo-main" src="@/assets/images/main/b184f159-77cb-4893-8a48-ecbf762080e0.png" alt="Logo with Claim" style="width: 230px;">
      <img class="logo-alt" src="https://franka.de/hubfs/logo.svg" alt="Logo" style="width: 30px;">
    </div>
    <nav >
      <!-- class="title-right" -->
      <ul class="navbar">
        <li class="dropdown c-mr-10 title-right">
          <a   @click="$router.push('/products')">产品</a>
          <ul class="dropdown-menu">
            <li><router-link to="/products/franka-research-3">Franka Research 3</router-link></li>
            <li><router-link to="/products/diana-7">Diana 7（FCI）</router-link></li>
            <!-- <li><router-link to="/products#product-add-ons">FR3 组件</router-link></li>  -->
            <li><router-link to="/accessories">配件</router-link></li>
             
          </ul>
          <!-- applications -->
        </li>
        <li class="dropdown c-mr-10 title-right">
          <a   @click="$router.push('/product-prototypes')">原型</a>
          <ul class="dropdown-menu">
            <li><router-link to="/fr3-duo">Franka Research 3 双机版（FR3 Duo）</router-link></li>
            <li><router-link to="/mobile-fr3-duo">移动式 FR3 双机版（Mobile FR3 Duo）</router-link></li>
            <li><router-link to="/tmr">触觉移动机器人（TMR ）</router-link></li>
            <li><router-link to="/gello">Franka GELLO 和 GELLO Duo</router-link></li>
          </ul>
        </li>
        <li class="dropdown c-mr-10 title-right">
          <a   @click="$router.push('/applications')">应用案例</a>
          <ul class="dropdown-menu">
            <li><router-link to="/applications#physical-ai-applications">物理 AI</router-link></li>
            <li><router-link to="/applications#application-research">科研领城</router-link></li>
            <li><router-link to="/applications#application-innovation">服务/创新</router-link></li> 
            <li><router-link to="/art">艺术</router-link></li> 
            <li><router-link to="/applications#application-industry">工业领域</router-link></li>
          </ul>
        </li>
        
        <li class="dropdown c-mr-10 title-right">
          <a   @click="$router.push('/resources')">资源中心</a>
          <ul class="dropdown-menu">
            <li><router-link to="/documents">产品文档</router-link></li>
            <li><router-link to="/develop">开发</router-link></li>  
            <li><router-link to="/community">社区贡献</router-link></li> 
            <li>
              <a href="https://www.franka-community.de/" class="light:text-dark-blue hover:light:text-dark-blue hover:no-underline lg:hover:underline !decoration-grey group-hover/is-submenu:no-underline block">社区论坛</a>
            </li> 
          </ul>
        </li>
        <li class="dropdown c-mr-10 title-right">
          <a   @click="$router.push('/events')">新闻动态</a>
          <ul class="dropdown-menu">
            <li><router-link to="/news">新闻中心</router-link></li> 
            <li><router-link to="/events">展会活动</router-link></li> 
            <li><router-link to="/webinars">线上研讨会</router-link></li>
          </ul>
        </li>
        <!-- <li class="title-right"><a @click="$router.push('/webinars')">在线研讨会</a></li> -->
        <!-- <li class="title-right"><a @click="$router.push('/careers')">职业生涯</a></li>  -->
        <li class="dropdown  c-mr-10 title-right"> 
          <a   @click="$router.push('/company')">关于我们</a>
          <ul class="dropdown-menu"> 
            <li><router-link to="/company">公司简介</router-link></li> 
            <li><router-link to="/careers">职业生涯</router-link></li>
            <li><router-link to="/partners">合作伙伴</router-link></li>  
            <li><router-link to="/contact"> 
              <img src="@/assets/images/focus/phone.svg" alt="" style="width: 12px;height: 12px;">
              联系我们 
              <span class="c-mt-10">4008686996</span>
            </router-link></li>
            <!-- <li><router-link to="/news">新闻</router-link></li>
            <li><router-link to="/events">事件</router-link></li>   -->
          </ul>
        </li>
         <!-- <div class="c-text-both"> -->
          <li class="dropdown  c-mr-10">
          <a href="#"> 
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg" style="width: 21px;height: 21px;cursor: pointer;" viewBox="0 0 512 512" class="w-[22px] h-auto fill-current">
              <g id="globe1_layer"><path d="M364.215 192h131.43c5.439 20.419 8.354 41.868 8.354 64s-2.915 43.581-8.354 64h-131.43c5.154-43.049 4.939-86.746 0-128zM185.214 352c10.678 53.68 33.173 112.514 70.125 151.992.221.001.44.008.661.008s.44-.008.661-.008c37.012-39.543 59.467-98.414 70.125-151.992H185.214zm174.13-192h125.385C452.802 84.024 384.128 27.305 300.95 12.075c30.238 43.12 48.821 96.332 58.394 147.925zm-27.35 32H180.006c-5.339 41.914-5.345 86.037 0 128h151.989c5.339-41.915 5.345-86.037-.001-128zM152.656 352H27.271c31.926 75.976 100.6 132.695 183.778 147.925-30.246-43.136-48.823-96.35-58.393-147.925zm206.688 0c-9.575 51.605-28.163 104.814-58.394 147.925 83.178-15.23 151.852-71.949 183.778-147.925H359.344zm-32.558-192c-10.678-53.68-33.174-112.514-70.125-151.992-.221 0-.44-.008-.661-.008s-.44.008-.661.008C218.327 47.551 195.872 106.422 185.214 160h141.572zM16.355 192C10.915 212.419 8 233.868 8 256s2.915 43.581 8.355 64h131.43c-4.939-41.254-5.154-84.951 0-128H16.355zm136.301-32c9.575-51.602 28.161-104.81 58.394-147.925C127.872 27.305 59.198 84.024 27.271 160h125.385z"></path></g></svg>
          </a>

          <ul class="dropdown-menu special-menu">
            <!-- <li><a href="https://franka.de/de/">Deutsch</a></li>
            <li><a href="https://franka.de/">English</a></li> -->
            <li style="background-color: #eef1f2;"><router-link to="/">中文(Chinese)</router-link></li>
          </ul>
          <!-- background-color: #5b727f; -->
        </li> 
        <button type="button" data-nav-toggle="" data-nav-toggled="true" :class="popValue?'foldMenu':'popMenu'" @click="changeMenu">
 
          <svg viewBox="0 0 80 80" width="15" height="15" :class="popValue?'foldContent':'popContent'">
            <rect width="80" height="10" rx="8" data-v-a209bf5e=""></rect>
            <rect y="30" width="80" height="10" rx="8" data-v-a209bf5e=""></rect>
            <rect y="60" width="80" height="10" rx="8" data-v-a209bf5e=""></rect>
          </svg>
        </button>
         <!-- </div> -->
       
      </ul>
    </nav> 
    <ul class="rightPop" v-show="popValue">
        <li class=" c-mr-10 rightLi">
          <a  class="titleMenu"  @click="$router.push('/products')">产品</a>
          <ul class="rightTitle" >
            <li><router-link to="/products/franka-research-3">Franka Research 3</router-link></li>
            <li><router-link to="/ai-services">AI服务</router-link></li>
            <li><router-link to="/products/diana-7">Diana 7（FCI）</router-link></li>
            <!-- <li><router-link to="/products#product-add-ons">FR3 Add-Ons</router-link></li>  -->
            <li><router-link to="/accessories">配件</router-link></li>
             
          </ul>
        </li>
        <li class="dropdown c-mr-10 title-right">
          <a   @click="$router.push('/product-prototypes')">原型</a>
          <ul class="dropdown-menu">
            <li><router-link to="/fr3-duo">Franka Research 3 双机版（FR3 Duo）</router-link></li>
            <li><router-link to="/mobile-fr3-duo">移动式 FR3 双机版（Mobile FR3 Duo）</router-link></li>
            <li><router-link to="/tmr">触觉移动机器人（TMR ）</router-link></li>
            <li><router-link to="/gello">Franka GELLO 和 GELLO Duo</router-link></li>
          </ul>
        </li>
        <li class=" c-mr-10 rightLi">
          <a   class="titleMenu" @click="$router.push('/applications')">应用案例</a>
          <ul class="rightTitle" >
            <li><router-link to="/applications#physical-ai-applications">物理 AI</router-link></li>
            <li><router-link to="/applications#application-research">科研领城</router-link></li>
            <li><router-link to="/applications#application-innovation">服务/创新</router-link></li> 
            <li><router-link to="/art">艺术</router-link></li> 
            <li><router-link to="/applications#application-industry">工业领域</router-link></li>
          </ul>
        </li> 
        <li class=" c-mr-10 rightLi">
          <a   class="titleMenu" @click="$router.push('/resources')">资源中心</a>
          <ul class="rightTitle" >
            <li><router-link to="/documents">产品文档</router-link></li>
            <li><router-link to="/develop">开发</router-link></li> 
            <li><router-link to="/community">社区贡献</router-link></li> 
            <li>
              <a href="https://www.franka-community.de/" class="light:text-dark-blue hover:light:text-dark-blue hover:no-underline lg:hover:underline !decoration-grey group-hover/is-submenu:no-underline block">社区论坛</a>
            </li> 
          </ul>
        </li>
        <li class=" c-mr-10 rightLi">
          <a   class="titleMenu" @click="$router.push('/events')">新闻动态</a>
          <ul class="rightTitle" >
            <li><router-link to="/events">展会</router-link></li>
            <li><router-link to="/news">资讯</router-link></li> 
            <li><router-link to="/webinars">线上研讨会</router-link></li>
          </ul>
        </li> 
        <li class="  c-mr-10 rightLi"> 
          <a   class="titleMenu" @click="$router.push('/company')">关于我们</a>
          <ul class="rightTitle" > 
            <li><router-link to="/company">公司简介</router-link></li> 
            <li><router-link to="/careers">职业生涯</router-link></li>
            <li><router-link to="/partners">合作伙伴</router-link></li> 
            <li><router-link to="/contact">联系我们</router-link></li>  
          </ul>
        </li> 
       
      </ul>
  </div>

    <router-view></router-view> <!-- 用来渲染匹配到的组件 -->
    
  <div class="px-container c-text-column c-text-both  c-mb-40" style="margin-top: 60px;">
      <div class="contact-title">联系我们</div>
      <div class="contact-email c-text-both">
        <img src="@/assets/images/focus/email.png" alt="" style="    height: 2.5vw; width: 2.5vw;margin-right: 1.04167vw;"> 
        china@franka.de
      </div>
      <div style="padding-top: 3.38542vw; font-weight: 400;  font-size: 1.35417vw; color: #283338;">
        or  
      </div>
      <div class = "focus_us footer-content-column"> 
          <div class = "media">
            <div v-for="(item, index) in focus_icon" :key="index"  class="icon-container">
              <div 
                class="icon-wrapper" 
                @mouseenter="showPopover(index)" 
                @mouseleave="hidePopover"
              >
                
                <!-- 显示二维码和信息的弹出层 -->
                <div v-show="popoverIndex === index&&item.qr" class="popover-content">
                  <img :src="item.qr" alt="QR code" class="qr-image" />
                  <div>{{ item.info }}</div>
                </div>
                <img :src="item.path" :alt="item.name" class="icon-image" @click="openUrl(item)"  :class="item.openUrl?'pointer':''"/>
                <div style=" font-weight: 600; font-size: 15px;">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
      </div>
  </div>
  
  <div class="line-with-text px-container"> 
    <hr class="divider">
  </div>
  <div class="c-text-between c-mb-40 c-flex-wrap">
      <div class="c-flex-1 c-text-vBetween c-text-left c-ml-40"> 
        <div class="pointer"> 免责声明 </div>
        <div class="pointer"> 隐私政策 </div>
        <div class="pointer"> 信息披露 </div> 
      </div>
      <div class="ending-width   c-text-column c-text-left  c-ml-40 "> 
              <h3 class="c-mb-20">FRANKA ROBOTICS</h3>
              <div>邮箱：china@franka.de</div>
              <div>电话：4008686996</div>
              <div> 
                备案号 franka-robotics.cn 京ICP备2021018784号-3 
              </div> 
      </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return { 
      // email.png
      popValue:false,
      popoverIndex: null, 
      focus_icon: [
        {
          name: '公众号',
          path: require('@/assets/images/focus/f80a3494ed51e79a4401460457c23826.jpg'),
          qr: require('@/assets/images/focus/dcf3e7df86e4614d1fbc7f53a5ade7f4.jpg'),
          info: '关注官方公众号'
        },
        {
          name: '视频号',
          path: require('@/assets/images/focus/cb163fdb7d364fde579e5b28e8e6f644.jpg'),
          qr: require('@/assets/images/focus/fac5bc8d6d33e2eef3071b8706cd65dc.jpg'),
          info: '关注官方视频号'
        },
        {
          name: '抖音号',
          path: require('@/assets/images/focus/14ea3768f46a981a39a6eb9ce4f18926.jpg'),
          openUrl:'https://www.douyin.com/user/MS4wLjABAAAAiFF4zryF3lhV0qLnP7SycQyQgnKC1wfb2ub5NDRmyynsmdxZ81DSd_-ktYSz0viw',
          // qr: require('@/assets/images/focus/qr_bilibili.png'),
          info: '关注官方抖音号'
        },
        {
          name: 'bilibili号',
          path: require('@/assets/images/focus/d476a7e510fe0b36c42ed23ce48da222.jpg'),
          openUrl:'https://space.bilibili.com/3546652379974202?plat_id=1&share_from=space&share_medium=android&share_plat=android&share_session_id=92c6e6d7-6770-485e-a0dd-037e7375a090&share_source=COPY&share_tag=s_i&timestamp=1719460266&unique_k=h9scRSp',
          // qr: require('@/assets/images/focus/qr_bilibili.png'),
          info: '关注官方bilibili 号'
        },
        {
          name: '小红书',
          path: require('@/assets/images/focus/redbook.png'),
          openUrl:'https://www.xiaohongshu.com/user/profile/67076d0e000000001d0227bb?xsec_token=YBsAwYNazYmd2Q3LhhMdYaOirBNVPA6ncNs-S0CF3z7tw%3D&xsec_source=app_share&xhsshare=CopyLink&appuid=5fc0c350000000000100abe0&apptime=1741072132&share_id=ae6cfcda46e344f68c77f6a0867c2527&share_channel=copy_link',
          // qr: require('@/assets/images/focus/qr_bilibili.png'),
          info: '关注官方微博号'
        }
      ],
    }
  },
  watch: {
    $route() {
      // 监听路由变化，跳转时将 popValue 设置为 false
      this.popValue = false;
    },
  },
  
  methods: {
    openUrl(item){
      if(!item.openUrl){
        return
      }else{
        window.open(item.openUrl)
      }
    },
    changeMenu(){
      this.popValue = !this.popValue 
      console.log(this.popValue)
    },
    // 显示弹出层
    showPopover(index) {
      this.popoverIndex = index; // 设置当前悬停的图标的索引
    },
    // 隐藏弹出层
    hidePopover() {
      this.popoverIndex = null; // 隐藏所有弹出层
    }
  }
  
};
</script>
<style scoped> 
  .icon-container {
    position: relative;
    display: inline-block;
  } 
  .icon-wrapper {
    position: relative;
  }
.popover-content {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  text-align: center;
  z-index: 10;
}

.qr-image {
  width: 100px;
  height: 100px;
}

  .icon-image {
    height: 4.58333vw;
    width: 4.58333vw;
    min-width: 40px;
    min-height: 40px;
    margin: 3.3vw 3.3vw 1vw 3.3vw;
    /* margin: 10px; */
  }
  @media (max-width: 999px) {
    .title-right{
      display: none;
    }
    .popMenu{
      display: block !important;
    }
    .foldMenu{
      display: block !important;
    }
  }
  .foldMenu{
    display: none;
   padding: 13.5px; 
   border: 0;
   background-color: #5b727f;
   color: white; 
   border-radius: 4px;
  }
  .popMenu{ 
    display: none;
   background-color: black;
   padding: 13.5px; 
   border: 0; 
   color: white; 
   border-radius: 4px;
  }
  .foldContent{
    fill:white
  }
  .popContent{  
    fill:white
  }
  .rightPop{
    position: absolute;
    right: 0;
    padding: 18px;
    top: 90px;
    background: #d5dbdc;
    overflow: auto;
    max-height: calc(100vh - 100px);
    text-align: left;
  }
  
/* 栅格布局，将 <ul> 设置为水平排列 */
ul.rightPop {
  list-style-type: none; 
}

/* 子菜单（下拉菜单）样式 */
ul.rightTitle { 
  list-style-type: none; 
}
 
.rightLi{

  margin-top: 5px; 
  margin-bottom: 16px;
}
.rightTitle{
  margin-bottom: 8px;
}
.titleMenu{
  font-size: 18px;
  margin-bottom: 10px;
  display: block;
}

.rightTitle li { 
  margin-top: 5px;
  margin-bottom: 5px;
  /* 相对定位，用于子菜单的绝对定位 */
  /* margin: 0 20px;   */
}
.contact-title{
  font-weight: 700;
  font-size: 1.97917vw;
  color: #000;
}
.contact-email{
  font-weight: 600;
  font-size: 1.97917vw;
  padding-top: 0.78125vw;
  color: #000;
}
.special-menu{
    left: -40px;
    width: 130px;
}
</style>